import { render, staticRenderFns } from "./SimpleKeyboardV2.vue?vue&type=template&id=76604774&"
import script from "./SimpleKeyboardV2.vue?vue&type=script&lang=js&"
export * from "./SimpleKeyboardV2.vue?vue&type=script&lang=js&"
import style0 from "./SimpleKeyboardV2.vue?vue&type=style&index=0&id=76604774&prod&lang=less&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports